import React, { Component } from 'react';
import './SolicitudesClienteEnviadas.css';
import { Link } from 'react-router-dom';
import { FaArrowCircleLeft } from 'react-icons/fa';
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip
} from '@mui/material';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getSolicitudesClienteRechazadas,
  clearErrors
} from '../../../redux/actions/dataasistencialactions';

export class SolicitudesClienteRechazadas extends Component {

    constructor(){
        super();
        this.state={
            
            errors:{},
            open:false,
            opendelete:false,
            cotizacionid:'',
            selectedFile: null,
        };
        
    };

    componentDidMount(){
        this.props.getSolicitudesClienteRechazadas(this.props.match.params.clienteId);
       }
  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 110,
        sortable: false,
        renderCell: (params) => (
          <Tooltip title="Ver Solicitud">
            <IconButton
              size="small"
              component={Link}
              to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}/solicitud/${params.row.solicitudid}`}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )
      },
      { field: 'titulo', headerName: 'Titulo', flex: 1 },
      { field: 'area', headerName: 'Area', flex: 1 },
      { field: 'servicio', headerName: 'Servicio', flex: 1 }
    ];

    const mapeosolicitudes = !loadingdataasistencial ? (
      <Box
        sx={{
          height: 500,
          width: '100%',
          mt: 2,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'primary.main',
            color: 'white'
          }
        }}
      >
        <DataGrid
          rows={Array.isArray(solicitudes) ? solicitudes : []}
          columns={columns}
          getRowId={(row) => row.solicitudid}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            )
          }}
        />
      </Box>
    ) : (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );


    return (
        <div>
        <div className="titulo_section">
        <div className="titulo_clientes">
        <h1 className="text-clientes">Mis Solicitudes de Compras Rechazadas</h1>
        <hr className="clientes_separator"></hr>            
        
        </div>

        <div className="div_boton">
        <Link to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}`} style={{ textDecoration: 'none' }}>
          <Tooltip title="Volver">
            <IconButton size="small">
              <FaArrowCircleLeft color="#03178C" size={20} />
            </IconButton>
          </Tooltip>
        </Link>
        </div>
        </div>


        <div className='table_container'>

            {mapeosolicitudes}

        </div>
        </div>
    )
  }
}

SolicitudesClienteRechazadas.propTypes = {
    
    getSolicitudesClienteRechazadas: PropTypes.func.isRequired,
    dataAsistencial:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    
  };

const mapActionsToProps={getSolicitudesClienteRechazadas,clearErrors};

const mapStateToProps = (state)=>({
    dataAsistencial:state.dataAsistencial,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(SolicitudesClienteRechazadas);

